module.exports = __webpack_public_path__ + "static/fanshawe-logo-a31c3b6bf6c2f5e1d84d204de56bbad5.png";